/* eslint-disable max-len */
import { Grid } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';
import BasicProPageWithHeader from '../../../layouts/BasicProLayout/BasicProPageWithHeader';
import ConfiguratorGlobalStyle from '../../../pages/portal/ConfiguratorApplicationEntrypoint/CarListingPage/ConfiguratorGlobalStyle';
import { type DefaultLayoutProps } from '../../default/Standard/Layout';
import { FooterGlobalStyle, type FooterGlobalStyleProps } from '../../GlobalStyles';
import { VwGlobalStyle } from '../VWGlobalStyles';

const StyledBasicProPageWithHeader = styled(BasicProPageWithHeader)`
    &.ant-pro-page-container {
        background-color: #fff;
    }

    & .ant-page-header-heading {
        justify-content: center;
        position: relative;
    }

    & .ant-page-header-back {
        position: absolute;
        left: 0;

        > .ant-page-header-back-button {
            color: var(--ant-primary-color);
            font-size: var(--button-font-size, 1rem);
        }

        > .ant-icon {
            color: currentColor;
            font-size: inherit;
        }
    }
`;

const ConfiguratorLayout = ({
    hasFooterBar = false,
    preferredMobileFooterHeight,
    footerType = 'default',
    footerMaxWidth,
    ...props
}: DefaultLayoutProps) => {
    const screens = Grid.useBreakpoint();
    const isMobile = useMemo(() => !screens.lg, [screens]);

    // Destructure FooterGlobalStyleProps properties
    const footerProps: FooterGlobalStyleProps = {
        hasFooterBar,
        footerType,
        footerMaxWidth,
        preferredMobileFooterHeight,
    };

    return (
        <>
            {isMobile ? <ConfiguratorGlobalStyle /> : <VwGlobalStyle />}
            <StyledBasicProPageWithHeader {...props} />
            <FooterGlobalStyle {...footerProps} />
        </>
    );
};

export default ConfiguratorLayout;
